Drupal.behaviors.wingsuitMenu = () => {
  return {
    isScrollDown: false,
    languageMenu: false,
    menuIsOpen: true,
    isOpenMenuLevel1: false,
    isOpenMenuLevel2: false,
  };
};
